<template>
    <div class="dml-image-list">
        <div class="dm-image-list__tab-wrap">
            <h3 v-for="(tab, index) in tabs"
                class="dml-image-list__tab"
                :class="{'dml-image-list__tab--active': isTabActive(index)}"
                v-on:click="handleTabChange(index)">
                {{ tab.name }}
            </h3>
        </div>
        <ul class="dml-image-list__content">
            <li class="dml-image-list__item"
                v-for="shop in currentShops">
                <a class="dml-image-list__image"
                   :href="shop.url"
                   :rel="shop.rel"
                   :target="shop.target"
                   data-ga="m_home.click_shop_logo"
                   :data-ga-label="shop.alt">
                    <img class="lazy"
                         src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                         :data-src="shop.imageUrl"
                         :alt="shop.alt" />
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'dm-promosale-shops',
        data: () => ({
            currentTabIndex: 0
        }),
        props: {
            tabs: {
                type: Array,
                required: true
            },
        },
        methods: {
            handleTabChange(newTab) {
                this.currentTabIndex = newTab;
            },
            isTabActive(index) {
                return this.currentTabIndex === index;
            },
        },
        computed: {
            currentShops() {
                return this.tabs[this.currentTabIndex] && this.tabs[this.currentTabIndex].shops;
            }
        }
    };
</script>
